// extracted by mini-css-extract-plugin
export var emptyState = "_5b-d";
export var statCard = "_5b-c";
export var table = "_5b-0";
export var tableCell = "_5b-4";
export var tableCellClickable = "_5b-5 _5b-4";
export var tableCellDefault = "_5b-6 _5b-4";
export var tableCellEmpty = "_5b-8";
export var tableCellWithValue = "_5b-7";
export var tableContainer = "_5b-e";
export var tableHeaderWeight = "_5b-1";
export var tableHeaderZone = "_5b-2";
export var tableRowHeader = "_5b-3";
export var viewModeButton = "_5b-9";
export var viewModeButtonActive = "_5b-a _5b-9";
export var viewModeButtonInactive = "_5b-b _5b-9";